import React from "react"
import UserList from "../components/UserList/UserList"
import { UserListContextProvider } from "../components/UserList/UserListContext"

const UserListContainer = () => {
  return (
    <div>
      <UserListContextProvider>
        <UserList />
      </UserListContextProvider>
    </div>
  )
}

export default UserListContainer
